import { styled } from "@mui/material";

export const StyledLinkSpan = styled("a")(() => {
  return {
    color: "#FC4C4C",
    fontSize: "14px",
    textDecoration: "underline",
    cursor: "pointer",
  };
});

export const StyledTextSpan = styled("span")(() => {
  return {
    color: "1F2123",
    fontSize: "14px",
    textDecoration: "none",
  };
});
